import React from 'react';
 const Navbar = () => {
    return <div>
        <nav className="navbar navbar-expand-lg navbar-white bg-black">
            <div className="container-fluid">
                <a className="navbar-brand" href="#">Case Converter</a>
            </div>
        </nav>
    </div>;
};

export default Navbar;